import React, { createContext, useState, useContext, ReactNode } from 'react';

interface FormContextType {
  isSubmissionFormOpen: boolean;
  setIsSubmissionFormOpen: (isOpen: boolean) => void;
}

const FormContext = createContext<FormContextType | undefined>(undefined);

interface FormProviderProps {
  children: ReactNode;
}

export const FormProvider: React.FC<FormProviderProps> = ({ children }) => {
  const [isSubmissionFormOpen, setIsSubmissionFormOpen] = useState(false);

  return (
    <FormContext.Provider value={{ isSubmissionFormOpen, setIsSubmissionFormOpen }}>
      {children}
    </FormContext.Provider>
  );
};

export const useForm = () => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error('useForm must be used within a FormProvider');
  }
  return context;
};